export default __webpack_public_path__ + "static/media/square-icon.379d26d1.svg";